import React, { useState, useEffect } from 'react';
import rgbToHex from './utils';

const SingleColor = ({ weight, rgb, hexColor, index }) => {
  console.log(hexColor);
  let color_value = rgb.join();
  const hexValue = `#${hexColor}`;

  const [alert, setAlert] = useState(false);
  useEffect(() => {
    let timeOut = setTimeout(() => {
      setAlert(false);
    }, 3000);
    return () => {
      clearTimeout(timeOut);
    };
  }, [alert]);

  return (
    <article
      className={`color ${index > 10 && 'color-light'}`}
      style={{ backgroundColor: `rgb(${color_value})` }}
      onClick={() => {
        setAlert(true);
        navigator.clipboard.writeText(hexValue);
      }}
    >
      <p className='percent-value'>{`${weight}%`}</p>
      <p className='color-value'>{hexValue}</p>
      {alert && <p>copy to clipboard</p>}
    </article>
  );
};

export default SingleColor;
